var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { open: _vm.openSuggestion },
      staticStyle: { position: "relative" },
    },
    [
      _c("input", {
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.updateValue($event.target.value)
          },
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.enter.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown",
                ])
              ) {
                return null
              }
              return _vm.down.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.up.apply(null, arguments)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "ul",
        { class: _vm.menuClass },
        _vm._l(_vm.matches, function (suggestion, index) {
          return _c(
            "li",
            {
              key: index,
              class: { active: _vm.isActive(index) },
              on: {
                click: function ($event) {
                  return _vm.suggestionClick(index)
                },
              },
            },
            [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v(_vm._s(suggestion.code) + " "),
                _c("small", [
                  _vm._v(
                    _vm._s(suggestion.name) + " - " + _vm._s(suggestion.city)
                  ),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }